import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import useBasename from '../../../../../../components/routing/useBasename';
import Button from '../../../../../../components/global/Button';
import { getAsset } from '../../../../../../util/assets';

const propTypes = {
  className: PropTypes.string,
  text: PropTypes.node.isRequired,
  withButton: PropTypes.bool,
};

const AccountCardNullState = ({ className, text, withButton = true }) => {
  const classes = classNames({
    'account-card-null-state': true,
    [className]: !!className,
  });

  const basename = useBasename();

  return (
    <div className={classes}>
      <img src={getAsset('/waldo-icon.svg')} alt="" />
      <div className="account-card-null-state-copy">{text}</div>

      {withButton && (
        <Button to={`/app/${basename}/account/cards/create`}>
          Send a Waldogram
        </Button>
      )}
    </div>
  );
};

AccountCardNullState.propTypes = propTypes;

export default AccountCardNullState;
